var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uc-notifications"},[_c('span',{class:_vm.iconClass}),_vm._v(" "),_c('div',{staticClass:"number",domProps:{"innerHTML":_vm._s(_vm.num)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a504602","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/views/layouts/header/uc-notifications.vue
// module id = 696
// module chunks = 0